import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Footer from '../../components/commonFooter';
import errorBoundary from '@ifeng-fe/errorBoundary';

class BottomFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <footer className={styles.footer}>
                <Chip id="20012" type="struct" title="底部公用版权" groupName="底部" content={content}>
                    <Footer />
                </Chip>
            </footer>
        );
    }
}

export default errorBoundary(BottomFooter);
